import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "../api";
import { useLang } from "../i18n";

export default function VerifyEmailPage() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const fired = useRef(false); // StrictMode double-invokes effects — fire once

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div data-testid="verify-email-page" className="mx-auto flex max-w-md flex-col px-4 py-20">
      <div className="rounded-2xl border bg-white p-8 text-center shadow-sm">
        {state === "loading" && <p className="text-slate-500">{t("verify.loading")}</p>}
        {state === "ok" && (
          <>
            <CheckCircle2 size={36} className="mx-auto text-emerald-600" />
            <h1 className="mt-4 font-heading text-xl font-bold">{t("verify.success")}</h1>
            <Link to="/logowanie" data-testid="verify-login-link" className="mt-4 inline-block text-sm font-semibold text-[#DC143C] hover:underline">
              {t("nav.login")} →
            </Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle size={36} className="mx-auto text-rose-600" />
            <h1 className="mt-4 font-heading text-xl font-bold">{t("verify.error")}</h1>
          </>
        )}
      </div>
    </div>
  );
}
